export * from './src/data-v2-data-collection-collections.universal.js';
